/**
 * Javascript Cookie Manager
 * Enforces GDPR Compliance: only setting cookies if cookies consent provided.
 *
 */
class Cookie {
    //https://www.compliancejunction.com/countries-subject-gdpr-privacy-law/
    GDPR_COUNTR_LOCALES = [
        'de-at',
        'fr',
        'hr',
        'cs',
        'da-dk',
        'el-cy',
        'et',
        'sv-fi',
        'de',
        'el-gr',
        'hu',
        'ie',
        'it',
        'lv',
        'lt',
        '-lb',
        'mt',
        'nl',
        'pl',
        'pt',
        'ro',
        'sk',
        'sl',
        '-es',
        '-uk',
    ]

    set(name, value, days, domain) {
        if (this.hasCookieConsent()) return

        var expires,
            domainStr = ''
        if (days) {
            var date = new Date()
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
            expires = '; expires=' + date.toGMTString()
        } else expires = ''
        if (domain !== undefined) {
            domainStr = ';domain=' + domain
        }
        document.cookie = name + '=' + value + expires + domainStr + '; path=/'
    }

    get(name) {
        var nameEQ = name + '='
        var ca = document.cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i]
            while (c.charAt(0) == ' ') c = c.substring(1, c.length)
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
        }
        return null
    }

    remove(name) {
        this.set(name, '', -1)
    }

    /**
     * Has user provided consent to drop cookies?
     * @return Boolean
     */
    hasCookieConsent() {
        return this.requiresConsent() //&& has givenConsent.
    }

    /**
     * Will be used to prompt user for cookie consent
     * @return Boolean
     */
    requiresConsent(type) {
        if (typeof this._requiresConsent != 'undefined') return this._requiresConsent

        //We use lagnage to determine locale
        this._requiresConsent = false
        var lang = ''
        if (navigator.language) lang = navigator.language
        else if (navigator.languages && navigator.languages.length > 0) lang = navigator.languages[0]
        else if (navigator.browserLanguage) lang = navigator.browserLanguage
        else if (navigator.systemLanguage) lang = navigator.systemLanguage
        lang = lang.toLowerCase()
        for (var i = this.GDPR_COUNTR_LOCALES.length - 1; i >= 0; i--) {
            var locale = this.GDPR_COUNTR_LOCALES[i]
            if (lang.indexOf(locale) >= 0) {
                this._requiresConsent = true
                break
            }
        }
        return this._requiresConsent
    }

    clearCookies() {
        var cookies = document.cookie.split('; ')
        for (var c = 0; c < cookies.length; c++) {
            var d = window.location.hostname.split('.')
            while (d.length > 0) {
                var cookieBase =
                    encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
                    '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
                    d.join('.') +
                    ' ;path='
                var p = location.pathname.split('/')
                document.cookie = cookieBase + '/'
                while (p.length > 0) {
                    document.cookie = cookieBase + p.join('/')
                    p.pop()
                }
                d.shift()
            }
        }
    }
}
export default new Cookie()
